import React, { useEffect, useRef, FC } from 'react';
import { List } from 'taxaroo-ui';
import { useTranslation } from 'react-i18next';
import { MessageEntity } from '~src/graphql';
import { useAppSelector } from '~src/redux/hooks';
import { selectSession } from '~src/redux/slices/sessionSlice';
import * as styles from './style.module.css';
import MessageAdmin from '../../molecules/MessageAdmin';
import MissedCall from '../../atoms/MissedCall';

interface MessagesListProps {
  data: Array<MessageEntity>;
}

const MessagesList: FC<MessagesListProps> = ({ data }) => {
  const { userId } = useAppSelector(selectSession);
  const { t: translation } = useTranslation();
  const messagesEndRef = useRef<any>(null);
  const scrollToBottom = () => {
    setTimeout(() => {
      messagesEndRef?.current?.scrollIntoView({ behavior: 'smooth' });
    }, 200);
  };

  useEffect(() => {
    scrollToBottom();
  }, [data]);

  return (
    <div className={styles.messagesListContainer}>
      <List
        header={<div />}
        footer={<div ref={messagesEndRef} />}
        bordered={false}
        dataSource={data}
        renderItem={(item: MessageEntity, index) => {
          const { firstName, lastName } = item.Users?.UserInformation ?? { firstName: '', lastName: '' };

          // item.isMissedCall ? (
          //   <MissedCall
          //     key={index}
          //     createdAt={new Date(item.createdAt)}
          //     text={translation('chat.messagesList.missedCall')}
          //     readDate={item.readDate !== null}
          //     isAdmin
          //   />
          // ) : (
          //   <MessageAdmin
          //     key={index}
          //     createdAt={new Date(item.createdAt)}
          //     mine={userId === item.userId}
          //     message={item.text}
          //     last={data.length === index + 1}
          //     name={`${} ${}`}
          //     attachment={item.attachment}
          //   />
          // )

          return (
            <MessageAdmin
              key={index}
              message={item.text}
              readDate={item.readDate}
              attachment={item.attachment}
              mine={userId === item.userId}
              last={data.length === index + 1}
              name={`${firstName} ${lastName}`}
              createdAt={new Date(item.createAt)}
              isSms={item.isSms}
            />
          );
        }}
      />
    </div>
  );
};

export default MessagesList;
